import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Backdrop, CircularProgress } from '@mui/material';
import { loaderStyles } from './ApplicationLoader.style';
var AppFallbackLoader = function () {
    var classes = loaderStyles().classes;
    return (_jsx(Backdrop, { className: classes.backdrop, open: true, "data-testid": 'application-loader', children: _jsx(Box, { className: classes.loaderContainer, children: _jsx(CircularProgress, { thickness: 2, size: 100, color: 'inherit' }) }) }));
};
export { AppFallbackLoader };
